import './CHeader.scss';
import { AiOutlineSearch, AiOutlineShoppingCart } from "react-icons/ai";
import logo from '../assets/clogo.png';
import { Link, useHistory } from 'react-router-dom'
import React, { useState, useEffect, useRef } from 'react';
import { HiOutlineHeart ,HiMenu} from "react-icons/hi";
import { BiBell } from "react-icons/bi";
import { FiChevronDown } from "react-icons/fi";
import Overlay from 'react-bootstrap/Overlay'
import Popover from 'react-bootstrap/Popover'
import axios from "axios";
import { globleAPI as Global } from '../globals'
import girl from '../assets/emojiwindle.png';

function CHeader(props: any) {
  const [localdata] = useState(localStorage.getItem('userid') || '')
  const [isShown, setIsShown] = useState(false);
  const [SugestionBox, setSugestionBox] = useState(false);
  const [DropdownHeading, setDropdownHeading] = useState('');
  const [SearchedValue, setSearchedValue] = useState('');
  const [DropDownData, setDropDownData] = useState<any>([]);
  const [SuggestionData, setSuggestionData] = useState<any>([]);
  const [token] = useState(localStorage.getItem('token') || '')
  const [first_name] = useState(localStorage.getItem('first_name') || '')
  const [last_name] = useState(localStorage.getItem('last_name') || '')
  const [imageProfile] = useState(localStorage.getItem('imageProfile') || '')
  const [show, setShow] = useState(false);
  const [ShowMobile, setShowMobile] = useState(false);
  const [TargetMobile, setTargetMobile] = useState(null);
  const [target, setTarget] = useState(null);
  const [ItemonSAle, setItemonSAle] = React.useState<any>([]);
  const ref = useRef(null);
  const [cart, setcart] = useState('')
  const history = useHistory();

  let UniqueBrands = [
    {
      "id": 139,
      "label": "Aigner",
    },
    {
      "id": 145,
      "label": "Armani",
    },
    {
      "id": 151,
      "label": "Balenciaga",

    },
    {
      "id": 152,
      "label": "Balmain Paris",

    },
    {
      "id": 159,
      "label": "Bottega Veneta",

    },
    {
      "id": 123,
      "label": "Watches",

    },
    {
      "id": 124,
      "label": "Accessories",

    },
    {
      "id": 164,
      "label": "Burberry",

    }
    , {
      "id": 165,
      "label": "Bvlgari",

    }
    , {
      "id": 168,
      "label": "Carolina Herrera",

    }
    , {
      "id": 169,
      "label": "Calvin Klein",

    }
    , {
      "id": 171,
      "label": "Cartier",

    }
    , {
      "id": 172,
      "label": "Celine",

    }
    , {
      "id": 173,
      "label": "Chanel",

    }
    , {
      "id": 179,
      "label": "Christian Dior",
    }
    , {
      "id": 186,
      "label": "Dior",

    }
    , {
      "id": 188,
      "label": "Dolce & Gabbana",

    }
    , {
      "id": 192,
      "label": "Fendi",

    }
    , {
      "id": 194,
      "label": "Giorgio Armani",

    }
    , {
      "id": 205,
      "label": "Jimmy Choo",

    }
    , {
      "id": 209,
      "label": "Kenzo",

    }
    , {
      "id": 213,
      "label": "Louis Vuitton",

    }
    , {
      "id": 219,
      "label": "Miu Miu",

    }
    , {
      "id": 221,
      "label": "Moschino",

    }
    , {
      "id": 232,
      "label": "Prada",

    }
    , {
      "id": 233,
      "label": "Ralph Lauren",

    }
    , {
      "id": 234,
      "label": "Ray-Ban",

    }
    , {
      "id": 241,
      "label": "Rolex",

    }
    , {
      "id": 242,
      "label": "Saint Laurent",

    }
    , {
      "id": 243,
      "label": "Salvatore Ferragamo",

    }
    , {
      "id": 247,
      "label": "Swarovski",

    }
    , {
      "id": 250,
      "label": "Tiffany & Co.",

    }
    , {
      "id": 251,
      "label": "Tissot",

    }
    , {
      "id": 252,
      "label": "Tom Ford",

    }
    , {
      "id": 254,
      "label": "Tod's",

    }
    , {
      "id": 255,
      "label": "Tory Burch",

    }
    , {
      "id": 259,
      "label": "Valentino",

    }
    , {
      "id": 261,
      "label": "Versace",

    }
    , {
      "id": 264,
      "label": "Yves Saint Laurent",

    }
    , {
      "id": 22,
      "label": "All Brands",

    }
  ];
  let shopallProducts = [
    {
      "id": 118,
      "label": "See All",
      "is_luxury": 0,
      "count": 187
    },
    {
      "id": 119,
      "label": "Bags",
      "is_luxury": 0,
      "count": 187
    },
    {
      "id": 120,
      "label": "Jewellery",
      "is_luxury": 0,
      "count": 166
    },
    {
      "id": 121,
      "label": "Clothing",
      "is_luxury": 0,
      "count": 504
    },
    {
      "id": 122,
      "label": "Shoes",
      "is_luxury": 0,
      "count": 100
    },
    {
      "id": 123,
      "label": "Watches",
      "is_luxury": 0,
      "count": 10
    },
    {
      "id": 124,
      "label": "Accessories",
      "is_luxury": 0,
      "count": 104
    },
    {
      "id": 125,
      "label": "Kids",
      "is_luxury": 0,
      "count": 54
    },
    {
      "id": 126,
      "label": "Others",
      "is_luxury": 0,
      "count": 42
    }
  ];
  let shopall = [
    {
      "id": 119,
      "label": "Bags",
      "is_luxury": 0,
      "count": 187
    },
    {
      "id": 120,
      "label": "Jewellery",
      "is_luxury": 0,
      "count": 166
    },
    {
      "id": 121,
      "label": "Clothing",
      "is_luxury": 0,
      "count": 504
    },
    {
      "id": 122,
      "label": "Shoes",
      "is_luxury": 0,
      "count": 100
    },
    {
      "id": 123,
      "label": "Watches",
      "is_luxury": 0,
      "count": 10
    },
    {
      "id": 124,
      "label": "Accessories",
      "is_luxury": 0,
      "count": 104
    },
    {
      "id": 125,
      "label": "Kids",
      "is_luxury": 0,
      "count": 54
    },
    {
      "id": 126,
      "label": "Others",
      "is_luxury": 0,
      "count": 42
    }
  ];
  let categories = [

    {
      "id": 30,
      "name": "Luxury Bags",
      "is_luxury": 1,
      "count": 17
    },
    {
      "id": 31,
      "name": "Luxury Jewellery",
      "is_luxury": 1,
      "count": 14
    },
    {
      "id": 32,
      "name": "Luxury Clothing",
      "is_luxury": 1,
      "count": 7
    },
    {
      "id": 33,
      "name": "Luxury Shoes",
      "is_luxury": 1,
      "count": 11
    },
    {
      "id": 34,
      "name": "Luxury Watches",
      "is_luxury": 1,
      "count": 1
    },
    {
      "id": 35,
      "name": "Luxury Accessories",
      "is_luxury": 1,
      "count": 10
    }
  ]
  let About = [{ label: 'How it works' }, { label: 'About us' },{ label: 'FAQs' }, { label: 'Advert' }, { label: 'Tips' }];
  let Sale = [{ label: 'Luxury Bags' }, { label: 'Luxury Jewllery' }, { label: 'Luxury Clothing' }, { label: 'Luxury shoes' }, { label: 'Luxury Watches' }, { label: 'Luxury Accessories' }, { label: 'Luxury Bags' }, { label: 'Luxury Jewllery' }, { label: 'Luxury Clothing' }, { label: 'Luxury shoes' },];

  useEffect(() => {
    getCartCount()
    GetSaleFilters()
  }, [])

  const GetSaleFilters = () => {

    axios
      .get(Global.GetSaleFilters)
      .then(response => {
        setItemonSAle(response.data.store_filters)
      })
      .catch(function (error) {
        console.log('response of the api ', error)
      });
  }

  const getCartCount = () => {
    axios
      .get("https://lesfemmestesting.dominioninc.org/public/api/GetCartCount?token=" + token)
      .then(response => {
        setcart(response.data.cart_count)
      })
      .catch(function (error) {
        console.log('response if the api is errror =', error)
      });
  }

  if (props.cartcheck === true) {
    getCartCount()
  }

  const handleClick = (event: any) => {
    setShow(!show);
    setTarget(event.target);
  };
  
  const handleClickMObile = (event: any) => {
    setShowMobile(!ShowMobile);
    setTargetMobile(event.target);
  };

  const move = (data: any) => {
    if (data === 'home') {
      history.push('/',[data])
    } else if (data === 'cart') {
      history.push('/cart')
    }

  };

  const logOut = () => {
    localStorage.removeItem('userid');
    localStorage.removeItem('token');
    window.location.reload();

  };

  const showDropDown = (data: any) => {
    if (data === 'shopall') {
      setDropDownData(shopallProducts)
      setIsShown(true)
      setDropdownHeading('SHOP ALL')
    } else if (data === 'Luxury Brands') {
      setDropDownData(UniqueBrands)
      setIsShown(true)
      setDropdownHeading(data)
    } else if (data === 'About') {
      setDropDownData(About)
      setIsShown(true)
      setDropdownHeading(data)
    } else if (data === 'Sale') {
      setDropDownData(Sale)
      setIsShown(true)
      setDropdownHeading(data)
    }
  };

  const dropDownClose = () => {

    setDropDownData('')
    setIsShown(false)
    setDropdownHeading('')

  };

  const goDown = (data:any) => {
    history.replace('/', [data]);
  };

  const moving = (data: any, data2: any) => {
    history.push('/all-products', [data, data2]);
    dropDownClose()
  };

  const movingWithSaleAll = (data: any, data2: any) => {
    console.log('this is the state before uoadating', data, data2)
    history.push('/all-products', [data, data2]);
    dropDownClose()
  };

  const movingLuxury = (data: any) => {
    history.push('/luxury-products', [data]);
    dropDownClose()
  };

  const movingWithSale = (data: any, data2: any) => {
    history.push('/luxury-products', [data, data2]);
    dropDownClose()
  };

  const searchedDataState = () => {
    if (SearchedValue == '') {
      alert('please add keyword')
    } else {
      history.push('/all-products', ['searchData',SearchedValue]);
    }
  };

  const searchedData = (data: any) => {
    history.push('/all-products', ['searchData',data]);

  };

  const itemonsale = (data: any) => {
    if (data.name == 'See All Sale') {
      history.push('/all-products', ['AllSale']);
    } else {
      history.push('/all-products', ['AllSalePercentage', data.discount]);
    }
  };

  const suggestion = (searchedKeyword: any) => {
    if (searchedKeyword == '') {
      setSuggestionData(searchedKeyword)
      setSugestionBox(false)
    } else {
      setSearchedValue(searchedKeyword)
      window.scrollTo(0, 0)
      axios
        .get(Global.GET_ALL_CLASSIFIED_ADS + token + "&search_keyword=" + searchedKeyword + "&is_luxury=0",)
        .then(response => {
          let Allsuggestion = response.data.AllProducts.filter((data: any, id: any) => id < 5)
          setSuggestionData(Allsuggestion)
          setSugestionBox(true)
        })
        .catch(function (error) {
          console.log('response of the api ', error)
        });
    }
  };

  const faqs = (data:any) => {
    history.push('/faqs', [data]);
};

  const reviewsection = () => {
    history.push('/', ['review']);
};

  const footerPages = (data:any) => {
    if(data == 'How it works'){
      history.push('/how-it-works', ['how']);
    }else if(data == 'About us'){
      history.push('/about-us');
    }else if(data == 'FAQs'){
      history.push('/faqs',['faq']);
    }
    
};

  return (
    <div className=' border-bottom  border-danger ' >
      <nav className="navbar navbar-expand  " style={{ height: '7vh' }} >
        <div className="container-fluid ">
          <div className='mobiledisplay ' style={{width: '100%', }}>
            <div className='mobiledisplay justify-content-between f-30 main-font primary-color   d-flex flex-row ' style={{width:'100%'}}>
                <div onClick={handleClickMObile} className="pointer cm-r-1rem  cp-t-5 material-icons primary-color">
                  <HiMenu size="2.1rem" />
                </div>
                <Overlay
                      show={ShowMobile}
                      target={TargetMobile}
                      placement="bottom"
                      container={ref.current}
                      containerPadding={50}
                    >
                      <Popover style={{ width: '80%', marginTop: '1.5%' }} id="popover-contained">
                        <Popover.Content >
                          <div className='d-flex flex-row border-bottom cp-b-10 ' >
                            <div className='cp-l-10 cp-t-10' >
                              <label className=" labelHeading label  main-font" >{first_name} {last_name}</label><br></br>
                              <label className="primary-color pText font-weight-bold  label main-font" >View Your Profile</label>
                            </div>
                          </div>

                          <div className='border-bottom cp-b-10 d-flex flex-column cp-10' >
                            <label onClick={()=>moving('itemCat', '118')} className=" pText  " >All Products</label>
                            <label onClick={() => moving('AllSale', '')}  className=" pText  " >Item on Sale</label>
                          </div>

                          <div className='border-bottom cp-b-10 d-flex flex-column cp-10' >
                            <label className=" pText " >  <Link to="/MyAccount" className="link " style={{ color: 'rgb(27, 27, 27)', border: 0 }} >My Account</Link> </label>
                            <label className=" pText  " >My Sales</label>
                            <label className=" pText " >  <Link to="/purchases" className="link " style={{ color: 'rgb(27, 27, 27)', border: 0 }} >My Purchases</Link> </label>
                          </div>
                          <div className='cp-b-10 d-flex flex-column cp-10' >
                            <label className=" pText " >  <Link to="/setting" className="link " style={{ color: 'rgb(27, 27, 27)', border: 0 }} >Settings</Link> </label>
                            <label onClick={() => faqs('faqs')} className=" pText " style={{ color: 'rgb(27, 27, 27)', border: 0 }} > Help Center </label>
                            <label onClick={() => logOut()} className='pText label touchAble hoverUnderLine' >Log Out </label>
                          </div>
                        </Popover.Content>
                      </Popover>
                    </Overlay>
              <div  >
                <img className="touchAble" onClick={() => move('home')} alt='img' height="50rem" src={logo} ></img>
              </div>
              <div onClick={() => move('cart')} className="pointer cm-r-1rem  cp-t-5 material-icons primary-color">
                  <p style={{ position: 'absolute', borderColor: 'black', borderRadius: 100, color: 'white', fontWeight: 'bold', backgroundColor: 'rgb(197, 77, 97)' }} className=' cp-l-6 f-13 cp-r-6 ' >{cart}</p>
                  <AiOutlineShoppingCart size="2.1rem" />
                </div>
            </div>
            <div></div>
          </div>
          <div className='webdisplay primary-color ' style={{ marginLeft: '2%' }}>
            <AiOutlineSearch size='1.7rem' onClick={() => searchedDataState()} />
            <input className='c-searchfield pText ' onChange={(text: any) => suggestion(text.target.value)} placeholder='Search by brand, item...' style={{ padding: 15 }}></input>
          </div>
          {SugestionBox == true ? (
            <div className=" d-flex flex-column position-absolute  cp-l-50 cp-r-50 cp-b-10 cm-l-25  " style={{ marginTop: '16.3%', zIndex: 1, backgroundColor: 'white', width: '50%' }} >
              {SuggestionData.map((data: any) =>
                <label onClick={() => searchedData(data.name)} >{data.name}</label>
              )}
            </div>
          ) : null}
          <div className="collapse navbar-collapse" style={{ justifyContent: 'space-between' }} id="navbarColor02">
            <form>
            </form>
            <div className='webdisplay  main-font primary-color  ' style={{ marginLeft: '12%' }}>
              <img className="touchAble" onClick={() => move('home')} width="150rem" alt='img' src={logo} ></img>
            </div>
            <div style={{ display: 'flex' }} className=' webdisplay'>
              <div onClick={() => goDown('gettheapp')}  className='pointer  cm-r-1rem  bg-color-secondary page-color  main-font f-200 border-radius cp-t-5 cp-b-5 cp-l-10 cp-r-10 d-flex  align-self-center'>
                <label  className="f-12 label touchAble" >
                  GET THE APP
                </label>
              </div>
              <div className='pointer  cm-r-1rem  bg-color-secondary page-color  main-font f-200 border-radius cp-t-5 cp-b-5 cp-l-10 cp-r-10 d-flex  align-self-center'>
                <label className="f-12 label" >   SELL</label>
              </div>
              <div >
                {localdata !== '' ? (
                  <div className="d-flex " >
                    {imageProfile !== 'null' ? (
                      <img alt="img" className="border" style={{ height: 40, width: 40, borderRadius: 100, marginRight: 2 }} src={Global.IMAGE_PATH + imageProfile}></img>
                    ) : (
                      <img alt="img" className="border" style={{ height: 40, width: 40, borderRadius: 100, marginRight: 2 }} src={girl}></img>
                    )}
                    <div className="cp-r-10 d-flex align-self-center" >
                    <FiChevronDown onClick={handleClick} className='touchAble' size='1.6rem' />
                    </div>
                    <Overlay
                      show={show}
                      target={target}
                      placement="bottom"
                      container={ref.current}
                      containerPadding={50}
                    >
                      <Popover style={{ width: '50%', marginTop: '1.5%' }} id="popover-contained">
                        <Popover.Content >
                          <div className='d-flex flex-row border-bottom cp-b-10 ' >
                            <div className='cp-l-10 cp-t-10' >
                              <label className=" secHeading label  main-font" >{first_name} {last_name}</label><br></br>
                              <label className="primary-color pText font-weight-bold  label main-font" >View Your Profile</label>
                            </div>
                          </div>
                          <div className='border-bottom cp-b-10 d-flex flex-column cp-10' >
                            <label className=" pText " >  <Link to="/MyAccount" className="link " style={{ color: 'rgb(27, 27, 27)', border: 0 }} >My Account</Link> </label>
                            <label className=" pText  " >My Sales</label>
                            <label className=" pText " >  <Link to="/purchases" className="link " style={{ color: 'rgb(27, 27, 27)', border: 0 }} >My Purchases</Link> </label>
                          </div>
                          <div className='cp-b-10 d-flex flex-column cp-10' >
                            <label className=" pText " >  <Link to="/setting" className="link " style={{ color: 'rgb(27, 27, 27)', border: 0 }} >Settings</Link> </label>
                            <label onClick={() => faqs('faqs')} className=" pText hoverUnderLine " style={{ color: 'rgb(27, 27, 27)', border: 0 }} > Help Center </label>
                            <label onClick={() => logOut()} className='pText label touchAble hoverUnderLine' >Log Out </label>
                          </div>
                        </Popover.Content>
                      </Popover>
                    </Overlay>
                  </div>
                ) : (
                  <div className="d-flex flex-row" >
                    <div className='cp-t-9  cp-l-10 cp-r-10 h6 main-font label'>
                      <Link to="/signup" className="link" style={{ color: 'rgb(27, 27, 27)' }} >Sign up </Link>
                    </div>
                    <div className='cp-t-9  cp-l-5 cp-r-18 h6 main-font label'>
                      <Link to="/login" className="link" style={{ color: 'rgb(27, 27, 27)', border: 0 }} > Login</Link>
                    </div>
                  </div>
                )}
              </div>
              <div className="pointer cm-r-1rem  cp-t-6 material-icons primary-color">
                <p style={{ position: 'absolute', borderColor: 'black', borderRadius: 100, color: 'white', backgroundColor: 'rgb(197, 77, 97)', fontSize: 11 }} className=' cp-l-4  cp-r-4 '  ></p>
                <BiBell size="1.5rem" />
              </div>
              <div className="pointer cm-r-1rem  cp-t-5 material-icons primary-color">
                <HiOutlineHeart size="1.7rem" />
              </div>
              <div onClick={() => move('cart')} className="pointer cm-r-1rem  cp-t-5 material-icons primary-color">
                <p style={{ position: 'absolute', borderColor: 'black', borderRadius: 100, color: 'white', backgroundColor: 'rgb(197, 77, 97)', fontSize: 11 }} className=' cp-l-4 f-13 cp-r-4 ' >{cart}</p>
                <AiOutlineShoppingCart size="1.6rem" />
              </div>
            </div>
          </div>
        </div>
      </nav>
      <div onMouseOver={() => setIsShown(false)} className=' Sansation-Regular  cp-3 page-color text-center bg-color-primary w100p ' >
        <label className='label f-13  ' style={{ fontStretch: 'ultra-expanded', letterSpacing: 4 }} > FREE       SHIPPING  for  orders  50  AED  and  above  in  UAE</label>
      </div>
      <div className='webdisplay display-flex justify-content-between padding cp-t-5 cp-b-3 label' >
        <div onClick={() => move('home')} className=' main-font  pointer f-14 f-700 text-color'  >
          <label className='d  main-font label  touchAble label' >Home</label>
        </div>
        <div className=' pointer f-14 f-700 text-color myDIV' style={{ color: DropdownHeading === 'SHOP ALL' ? 'rgb(218, 95, 115)' : 'black' }} onMouseEnter={() => showDropDown('shopall')} >
          <label className='   main-font label touchAble' style={{}} > Shop All</label>
        </div>
        <div className=' pointer f-14 f-700 text-color    dropdown' >
          <div className=' pointer f-14 f-700 text-color myDIV' style={{ color: DropdownHeading === 'Luxury Brands' ? 'rgb(218, 95, 115)' : 'black' }} onMouseEnter={() => showDropDown('Luxury Brands')} >
            <label className='  main-font label  touchAble ' style={{}} >Luxury Brands</label>
          </div>
        </div>
        <div className='  pointer f-14 f-700 text-color    dropdown' >
          <div className=' pointer f-14 f-700 text-color myDIV' style={{ color: DropdownHeading === 'Sale' ? 'rgb(218, 95, 115)' : 'black' }} onMouseEnter={() => showDropDown('Sale')} >
            <label className='  main-font label  touchAble ' style={{}} >Sale</label>
          </div>
        </div>
        <div className='  main-font label   pointer f-14 f-700 text-color   '>
          <label className='d  main-font label touchAble' > My Store</label>
        </div>
        <div className=' pointer f-14 f-700 text-color    dropdown' >
          <div className=' pointer f-14 f-700 text-color myDIV' style={{ color: DropdownHeading === 'About' ? 'rgb(218, 95, 115)' : 'black' }} onMouseEnter={() => showDropDown('About')} >
            <label className='  main-font label  touchAble ' style={{}} >About</label>
          </div>
        </div>
        <div  onClick={() => goDown('review')} className='main-font label   pointer f-14 f-700 text-color'>
          <label className='  main-font touchAble label'  >Reviews</label>
        </div>
        <div className=' main-font  pointer f-14 f-700 text-color    '>
          <label className='  main-font touchAble label' > Blog</label>
        </div>
        <div className=' main-font  pointer f-14 f-700 text-color    '>
          <label className='  main-font touchAble label' > Contact Us</label>
        </div>
      </div>
      {isShown && (
        <div className=" page-left-padding page-right-padding border-top border-danger cp-b-20" style={{ zIndex: 1, backgroundColor: 'white', }} onMouseLeave={() => dropDownClose()} >
          <div className="  d-flex flex-column" style={{ marginRight: '7%', marginLeft: '7%', flexWrap: 'wrap', maxHeight: '60vh' }} >
            {DropdownHeading == 'Sale' ? (
              <div>
                <div className="d-flex flex-row  justify-content-md-start"  >
                  <div className="col-md-6  col d-flex flex-row"  >
                    <div className="col-6  col"  >
                      <label className=" labelHeading  text-capitalize cp-t-20 main-font" style={{ color: '#ababab' }} >SALE</label><br></br>
                      <label className=" label pText hoverColor touchAble main-font" onClick={() => movingLuxury('AllSaleLuxury')} style={{ flexWrap: 'wrap' }}  >All Sale Luxury</label>
                      {categories.map((data: any) =>
                        <div onClick={() => movingWithSale('CategoryProducts', data.id)} className="flex-wrap " style={{ flexWrap: 'wrap' }} >
                          <label className=" label pText hoverColor touchAble main-font" style={{ flexWrap: 'wrap' }}  >{data?.label}{data?.name}</label>
                        </div>
                      )}
                    </div>
                    <div className="col-6 col" >
                      <label className="labelHeading text-capitalize cp-t-20 main-font" style={{ color: 'white' }} >{DropdownHeading}</label><br></br>
                      <label onClick={() => moving('AllSale', '')} className=" label pText hoverColor touchAble main-font" style={{ flexWrap: 'wrap' }}   >All Sale Top Brands</label>
                      {shopall.map((data: any) =>
                        <div className="flex-wrap " style={{ flexWrap: 'wrap' }} >
                          <label onClick={() => movingWithSaleAll('AllCat', data.id)} className=" label pText hoverColor touchAble main-font" style={{ flexWrap: 'wrap' }}  >{data?.label}{data?.name}</label>
                        </div>
                      )}</div>
                  </div>
                  <div className="col-md-6" >
                    <label className="labelHeading text-capitalize cp-t-20 main-font" style={{ color: '#ababab' }} >PERCENTAGE</label>
                    <div className="flex-wrap d-flex flex-column " style={{ flexWrap: 'wrap' }} >
                      {ItemonSAle.length >= 1 &&
                        <div className="d-flex flex-column" >
                          {ItemonSAle.map((data: any) =>
                            <label onClick={() => itemonsale(data)} className=" label pText hoverColor touchAble main-font" style={{ flexWrap: 'wrap' }}  >{data.name}</label>
                          )}
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
            ) : DropdownHeading == 'Luxury Brands' ? (
              <div className=" d-flex flex-column "  >
                <div className=" d-flex flex-column "   >
                
                    <label className="labelHeading text-capitalize cp-t-20 main-font" style={{ color: '#ababab', }} >EDITOR'S PICK</label>
                  
                  <div className="d-flex flex-column " style={{ maxHeight: '45vh', flexWrap: 'wrap', width: '70%' }} >
                    {DropDownData.map((data: any) =>
                      <div onClick={() => data.label == 'All Brands' ? movingWithSale('Luxury Products', data.name) : movingWithSale('BrandsProducts', data.label)}    >
                        <label className=" label pText  hoverColor touchAble flex-wrap main-font" style={{ flexWrap: 'wrap' }}  >{data?.label}</label>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ) : DropdownHeading == 'SHOP ALL' ? (
              <div>
                <label className="labelHeading text-capitalize cp-t-20 main-font" style={{ color: '#ababab', }} >{DropdownHeading}</label>
                {DropDownData.map((data: any) =>
                  <div onClick={() => DropdownHeading === 'SHOP ALL' ? moving('itemCat', data.id) : console.log('')} className="flex-wrap " style={{ flexWrap: 'wrap' }} >
                    <label className="label pText  hoverColor touchAble flex-wrap main-font" style={{ flexWrap: 'wrap' }}  >{data?.name}{data?.label}</label>
                  </div>
                )}
              </div>
            ):(
              <div>
              <label className="labelHeading text-capitalize cp-t-20 main-font" style={{ color: '#ababab', }} >{DropdownHeading}</label>
              {DropDownData.map((data: any) =>
                <div onClick={() =>footerPages(data.label)} className="flex-wrap " style={{ flexWrap: 'wrap' }} >
                  <label className="label pText  hoverColor touchAble flex-wrap main-font" style={{ flexWrap: 'wrap' }}  >{data?.name}{data?.label}</label>
                </div>
              )}
            </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default CHeader;
